var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._v("我是一个公共头")])}
var staticRenderFns = []

export { render, staticRenderFns }